import { render } from "./P_HeavyBowgun.vue?vue&type=template&id=14ffdd39&scoped=true"
import script from "./P_HeavyBowgun.vue?vue&type=script&lang=js"
export * from "./P_HeavyBowgun.vue?vue&type=script&lang=js"

import "./P_HeavyBowgun.vue?vue&type=style&index=0&id=14ffdd39&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ffdd39"]])

export default __exports__